import { reactive, ref } from "vue";
import { queryHandleTable } from "@/api/handle";

export default function useHandleTable() {
  // 搜索条件ref
  const searchRef = ref(null);

  // 详情ref
  const adjustRef = ref(null);

  const time = ref([]);

  // 搜索条件
  const searchData = reactive({
    processDefinitionName: "",
    processDefinitionKey: "",
    completeType: "",
    startTime: "2023-01-01 00:00:00",
    endTime: "2100-01-01 00:00:00",
  });

  // 表格loading
  const tableLoading = ref(false);

  // 表格数据
  const tableData = ref([]);

  // 表格列配置
  const columns = ref([
    {
      label: "流程id",
      prop: "id",
    },
    {
      label: "流程名称",
      prop: "processDefinitionName",
    },
    {
      label: "流程key",
      prop: "processDefinitionKey",
    },
    {
      label: "发起时间",
      prop: "startTime",
    },
    {
      label: "结束时间",
      prop: "endTime",
    },
    {
      label: "状态",
      prop: "completeType",
    },
  ]);

  // 分页数据
  const pages = reactive({
    page: 1,
    limit: 10,
    total: 0,
  });

  // 获取页面数据
  const getList = () => {
    tableLoading.value = true;
    queryHandleTable({
      page: pages.page,
      limit: pages.limit,
      ...searchData,
    })
      .then((res) => {
        tableData.value = res.data.records;
        pages.total = res.data.total;
      })
      .finally(() => {
        tableLoading.value = false;
      });
  };

  // 重置
  const handleReset = () => {
    searchRef.value?.resetFields();
    (searchData.startTime = "2023-01-01 00:00:00"),
      (searchData.endTime = "2100-01-01 00:00:00");
    time.value = [];
    getList();
  };

  // 详情
  const handleDetail = (row) => {
    adjustRef.value.handleDialogOpen(row.id);
  };

  // 时间选择器变化
  const dateTimeChange = (val) => {
    if (val) {
      searchData.startTime = val[0];
      searchData.endTime = val[1];
    } else {
      (searchData.startTime = "2023-01-01 00:00:00"),
        (searchData.endTime = "2100-01-01 00:00:00");
    }
  };
  return {
    searchRef,
    searchData,
    tableLoading,
    tableData,
    columns,
    pages,
    adjustRef,
    time,
    getList,
    handleReset,
    handleDetail,
    dateTimeChange,
  };
}
